var map = {
	"./agents": 823,
	"./agents.svg": 823,
	"./ai_bot": 824,
	"./ai_bot.svg": 824,
	"./arrow-down": 701,
	"./arrow-down.svg": 701,
	"./calendar": 825,
	"./calendar.svg": 825,
	"./chats-circle": 826,
	"./chats-circle.svg": 826,
	"./configuration": 827,
	"./configuration.svg": 827,
	"./creditcard-toolbox": 828,
	"./creditcard-toolbox.svg": 828,
	"./dashboard": 829,
	"./dashboard.svg": 829,
	"./header-logo": 702,
	"./header-logo.svg": 702,
	"./menu": 830,
	"./menu.svg": 830,
	"./onboarding": 831,
	"./onboarding.svg": 831,
	"./pm-icon": 832,
	"./pm-icon.png": 832,
	"./question-mark": 833,
	"./question-mark.svg": 833,
	"./receipt": 834,
	"./receipt.png": 834,
	"./rule": 835,
	"./rule.svg": 835,
	"./subscription": 836,
	"./subscription.png": 836,
	"./task-list-square-right": 837,
	"./task-list-square-right.svg": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 822;